//Library Imports
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import store, { RootState } from "store";

//Local Imports
import EmailWrapper from "../Emails/Components/EmailWrapper";
import { PATH_ASSET, TAB_CAMPAIGNS, PATH_EDITION_EDIT } from "constants/paths";
import AssetWithoutCampaignWrapper from "../AssetsWithOutCampaigns/Components/AssetWithoutCampaignWrapper";
import {
  getCampaignList,
  resetRecommendedContacts,
  resetRecommendedLists,
} from "../CampaignAssets/actions";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import DetailProfile from "../Audience/People/DetailProfile";
import CreateContactSidebar from "../Audience/People/CreateContactSidebar";
import CampaignAssetsV2 from "../CampaignsDashboard/CampaignAssetsV2";
import EditionEditWrapper from "../Edition/EditionEditWrapperV2";
import { ICampaignItem } from "../interfaces";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import { getAssetDetails, getCampaignDetails } from "../Emails/actions";
import { getQuarterDates } from "utils";
import { AUDIENCE_LISTS } from "constants/types";
import { getAudienceListsNamesOnlyService } from "modules/Services/AudienceService";

interface Props {
  tab?: string;
  page?: string;
  subTab?: string;
}

const CampaignWrapperInner = (props: Props) => {
  const { tab, page, subTab } = props;
  const showDetailProfile = useSelector((state: RootState) => state.audience.showDetailProfile);
  const reset: boolean = useSelector((state: RootState) => state.campaigns.reset);
  const campaignPages: number = useSelector((state: RootState) => state.campaigns.page);
  const campaigns: ICampaignItem[] = useSelector((state: RootState) => state.campaigns.data);
  const openEditContactSidebar = useSelector((state: RootState) => state.peopleAudience.openEditContactSidebar);
  const articleSidebarPreviewInDetailProfile = useSelector(
    (state: RootState) => state.uiReducer.articleSidebarPreviewInDetailProfile
  );
  const newListCreated = useSelector((state: RootState) => state.audienceLists.newListCreated);
  const [showEditContactAsider, setShowEditContactAsider] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "auto";
    return () => {
      // reset get recommended lists and people
      resetRecommendedLists();
      resetRecommendedContacts();
    };
  }, []);

  const showEditContactAsiderHandler = (value: boolean) => {
    setShowEditContactAsider(value);
  };

  const quarter_dates = getQuarterDates();

  useEffect(() => {
    if (!showDetailProfile) {
      setShowEditContactAsider(false);
    }
  }, [showDetailProfile]);

  useEffect(() => {
    // only call apis when user lands on campaigns page not edition page
    if ((page === undefined || page === "/") && tab === undefined) {
      // console.log("campaigns.length", page, tab, campaigns.length)
      if (campaigns.length === 0 || reset) {
        getCampaignList(
          { offset: 0, limit: 20, start_date: quarter_dates.start_date, end_date: quarter_dates.end_date },
          false
        );
        if (getQueryCampaignId()) getCampaignDetails();
        if (getQueryEmailId()) getAssetDetails();
      } else if (campaigns.length > 0 && campaignPages < 2) {
        getCampaignList(
          {
            offset: campaigns.length,
            limit: 20,
            start_date: quarter_dates.start_date,
            end_date: quarter_dates.end_date,
          },
          false
        );
      }
    }
  }, [page, tab]);

  useEffect(() => {
    if (newListCreated) {
      store.dispatch({
        type: AUDIENCE_LISTS.NAMES_LOAD,
      });
      getAudienceListsNamesOnlyService()
        .then((res) => {
          const { success, data } = res.data;
          if (success) {
            if (data.length > 0) {
              const lists = data[0].lists;
              store.dispatch({
                type: AUDIENCE_LISTS.NAMES_LOAD_SUCCESS,
                listsDataNames: lists,
                payload: { listsDataNames: lists, },
              });
            }
          }
        })
        .catch((err) => {
          store.dispatch({
            type: AUDIENCE_LISTS.NAMES_FAIL,
          });
        });
    }
  }, [newListCreated])

  return (
    <>
      <Wrapper className={page === undefined || page === "/" || tab === undefined ? "right-sidbar" : ""}>
        {page === undefined || page === "/" ? (
          <CampaignAssetsV2 />
        ) : page === TAB_CAMPAIGNS.CONTENT && tab !== PATH_ASSET ? (
          <EmailWrapper tab={tab} subTab={subTab} />
        ) : page === PATH_EDITION_EDIT || page === TAB_CAMPAIGNS.PUBLISH || page === TAB_CAMPAIGNS.DESIGN ? (
          <EditionEditWrapper tab={tab} />
        ) : page === PATH_ASSET ? (
          <div className="AssetWithoutCampaignWrapper-wrapper">
            <AssetWithoutCampaignWrapper />
          </div>
        ) : null}
        <FloatingSidebarTwo isToggle={openEditContactSidebar}>
          <CreateContactSidebar detailProfileAsider={true} editSidebar={true} />
        </FloatingSidebarTwo>
        <FloatingSidebarTwo
          showEditContactAsiderHandler={showEditContactAsiderHandler}
          showEditContactAsider={showEditContactAsider}
          isToggle={showDetailProfile}
          ProfileSidebar={true}
          className="detail-person-view"
          articleSidebarPreviewInDetailProfile={articleSidebarPreviewInDetailProfile}
        >
          <DetailProfile showEditContactAsiderHandler={showEditContactAsiderHandler} />
        </FloatingSidebarTwo>
      </Wrapper>
    </>
  );
};

export default CampaignWrapperInner;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 140px 90px 0 90px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 100px 65px 0 65px;
  }
  &.right-sidbar {
    background-color: #f9f8f6;
    padding: 120px 0px 0 65px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 90px 0px 0 50px;
    }
  }
  .AssetWithoutCampaignWrapper-wrapper {
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      /* margin: 0 -20px; */
      /* width: calc(100% + 55px); */
      width: calc(100% + 35px);
    }
    > div:nth-of-type(1) {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: calc(100% - 80px);
      }
    }
  }
`;
